import * as Yup from 'yup';

export const notPoBoxRegEx = /^ *(?!((#\d+)|((box|bin)[-. /\\]?\d+)|(.*p[ .]? ?(o|0)[-. /\\]? *-?((box|bin)|b|(#|num)?\d+))|(p(ost)? *(o(ff(ice)?)?)? *((box|bin)|b)? *\d+)|(p *-?\/?(o)? *-?box)|.*?post office box|((box|bin)|b) *(number|num|#)? *\d+|(num|number|#) *\d+))/i;


export const isNotPoBox = (street) => notPoBoxRegEx.test(street);
export const phoneRegExUS = /^([1][\s-./]?)?(\(?[0-9]{3}\)?|[0-9]{3})[\s-./]?([0-9]{3}[\s-./]?[0-9]{4}|[0-9]{7})$/;
export const fullFirstAndLastMiddleOptional = /^([a-z'-]{2,}(?:\s[a-z]{1,})?)\s([a-z'-]{2,})$/i;


export const postalCodeUS = /^\d{5}(-\d{4})?$/;
export const postalCodeCA = /^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} *\d{1}[A-Z]{1}\d{1}$/;
export const postalCodeGB = /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) [0-9][A-Za-z]{2})$/;

export const intlPostalCodeRegexes = {
    US: postalCodeUS,
    CA: postalCodeCA,
    GB: postalCodeGB
};
export const postalCodeYupSchema = (countryCode = 'US', message = 'Invalid postal code.') =>
    Yup.string().matches(intlPostalCodeRegexes[countryCode], { message });
